import React, { useEffect, useRef, useState } from 'react';
// import Title from "./Title";
import './Banner.css';

const heroVideo = "https://storage.googleapis.com/apt300-assets-ace-ellipse-406710/videos/apt300-runway-720.mp4";

function Banner() {
    const videoRef = useRef(null);
    const [showScrollCue, setShowScrollCue] = useState(true);

    const playHeroVideo = () => {
        const video = videoRef.current;

        if (!video || !video.paused) {
            return;
        }

        const playPromise = video.play();
        if (playPromise?.catch) {
            playPromise.catch(() => {});
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollCue(window.scrollY < 16);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const handleFirstInteraction = () => {
            playHeroVideo();
        };

        window.addEventListener('touchstart', handleFirstInteraction, { passive: true });
        window.addEventListener('pointerdown', handleFirstInteraction);
        window.addEventListener('scroll', handleFirstInteraction, { passive: true });

        return () => {
            window.removeEventListener('touchstart', handleFirstInteraction);
            window.removeEventListener('pointerdown', handleFirstInteraction);
            window.removeEventListener('scroll', handleFirstInteraction);
        };
    }, []);

    const handleScrollCueClick = () => {
        document.getElementById('ticketList')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div
            className="apt-hero"
        >
            <video
                ref={videoRef}
                autoPlay
                loop
                muted
                playsInline
                className="apt-hero-video"
            >
                <source src={heroVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <button
                type="button"
                className={`apt-hero-scroll ${showScrollCue ? '' : 'is-hidden'}`}
                onClick={handleScrollCueClick}
                aria-label="Scroll to tickets"
                aria-hidden={!showScrollCue}
                tabIndex={showScrollCue ? 0 : -1}
            >
                <span className="apt-hero-scroll-dot" />
            </button>
            {/* <Title /> */}
        </div>
    );
}

export default Banner;
